import useAdditionalParameters from '../hooks/useAdditionalParameters';
import { useCheckLoadedAndShow } from '../hooks/useCheckLoadedAndShow';
import useLocationLoadCompleteCallback from '../hooks/useLocationLoadCompleteCallback';
// Some valid URLs:
// https://payroll.toasttab.com/lqbrewing/dashboard
// https://payroll.toasttab.com/kizik/dashboard
// https://any-domain.com/any/path/dashboard
export var TOAST_FINAL_DEST_REGEXP = /^https:\/\/[^/]+\/[^/]+\/dashboard$/;
export function useToast() {
    var addAdditionalParameters = useAdditionalParameters().addAdditionalParameters;
    useLocationLoadCompleteCallback(TOAST_FINAL_DEST_REGEXP, function (landingUrl) {
        addAdditionalParameters({ landingUrl: landingUrl });
    });
    useCheckLoadedAndShow();
}
